const additionalCostListFields = [
  {
    label: 'Jenis Biaya Tambahan',
    key: 'name',
    name: 'name',
    validation: 'required',
    editable: true,
    isSortable: true,

    thStyle: 'width: 20%',
  },
  {
    label: 'Status',
    key: 'status.name',
    name: 'status',
    validation: 'required',
    editable: true,
    isSortable: true,

    // NOTE: Probably better to use Switch in this case
    // type: 'switch',
    // valueTrue: 'ACTIVE',
    // valueFalse: 'INACTIVE',
    // valueLabelTrue: 'Aktif',
    // valueLabelFalse: 'Non Aktif',
    // customValueFn: (obj) => {
    //   if (!obj.status) return
    //   return obj.status.name == 'Aktif' ? 'ACTIVE' : 'INACTIVE'
    // },

    type: 'select-resourceful',
    trackBy: 'value',
    optionsGetter,
    getInitialObject,
    customValueFn,
    optionLabelFn: ({ item }) => item.name,

    thStyle: 'width: 20%',
  },
  {
    label: 'Keterangan',
    key: 'description',
    name: 'description',
    validation: 'required',
    editable: true,
  },
]

function customValueFn(obj) {
  if (!obj.status) return

  return obj.status.name == 'Aktif' ? 'ACTIVE' : 'INACTIVE'
}

function getInitialObject(obj) {
  if(!obj.status) return

  const transformedObj = {
    ...obj.status,
    value: obj.status.name == 'Aktif' ? 'ACTIVE' : 'INACTIVE',
  }
  return transformedObj
}

async function optionsGetter() {
  return {
    metadata: {
      total_page: 1,
      total_count: 2,
      page: 1,
    },
    data: {
      paginated_result: [
        { name: 'Aktif', value: 'ACTIVE' },
        { name: 'Non Aktif', value: 'INACTIVE' },
      ],
    },
  }
}

export default additionalCostListFields
